import * as _ from 'lodash';
import { type ColumnHandler } from '../types';
import { parseJson, parseNumber, parseString } from '../converters';
import { type FileColumnType, type Asset } from '../../monday-api/api';

export type FileColumnValue = {
  text: string | null;
  asset_ids: number[] | null;
  assets: Asset[] | null;
  // links: string[] | null;
};

const handler: ColumnHandler<FileColumnType, FileColumnValue> = {
  type: 'file',

  default_value_field: 'text',

  convertValueFromMondayToEngine: (columnValue) => {
    const text = parseString(columnValue.text);
    const value = parseJson(columnValue.value);
    let assetIds: number[] | null = null;
    let assets: Asset[] | null = null;

    if (Array.isArray(_.get(value, 'files'))) {
      assetIds = ((_.get(value, 'files') || []) as Array<{ assetId: number }>)
        .map(({ assetId }) => parseNumber(assetId))
        .filter((assetId) => assetId !== null) as number[];
    }

    // this will be set if the items were fetched with assets
    if (Array.isArray(_.get(columnValue, 'files'))) {
      assets = (_.get(columnValue, 'files') || [])
        .map((file: any) => {
          return file?.asset;
        })
        .filter((asset) => !!asset);
    }

    return {
      text,
      asset_ids: assetIds,
      assets,
    };
  },

  // currently not supported by monday
  getFormulaValue: (engineValue) => (engineValue.text === null ? '' : engineValue.text),
};

export default handler;
